import type {HTMLAttributes} from 'react'
import {NavLink} from 'react-router-dom'
import styled, {css} from 'styled-components'

import {tokens} from '@pleo-io/telescope'

import type {TabsProps} from './tabs'

export interface TabProps extends HTMLAttributes<HTMLAnchorElement> {
    to?: string
    active?: boolean
    tall?: boolean
    testId?: string
}

const tallStyles = ({tall}: TabProps) =>
    tall &&
    css`
        padding-bottom: ${tokens.spacing18};
        margin-bottom: calc(-1 * ${tokens.spacing20});
    `

const tab = css`
    padding-bottom: ${tokens.spacing6};
    ${tallStyles}
    display: inline-block;
    font-size: 14px;
    white-space: nowrap;
    line-height: ${tokens.lineHeight3};
    color: ${tokens.shade600};
    cursor: pointer;
    transition: ${tokens.fastInOut};
    transition-property: color, border-bottom;
    border-bottom: 1px solid transparent;

    &:hover {
        color: ${tokens.shade800};
        border-bottom: 1px solid ${tokens.shade400}; /* stylelint-disable-line */
    }

    &:focus-visible {
        outline: 3px solid transparent; /* stylelint-disable-line */
        box-shadow: inset 0 -4px 0 0 ${tokens.shade900}; /* stylelint-disable-line */
        transition: ${tokens.smoothInOut};
        transition-property: box-shadow;
    }

    &.active {
        font-weight: ${tokens.fontWeightSemibold};
        color: ${tokens.shade800};
        border-bottom: ${tokens.borderDark};

        &:hover {
            border-bottom: 1px solid ${tokens.pink500}; /* stylelint-disable-line */
        }
    }
`
export const TabLink = styled(NavLink)`
    ${tab}
`
export const TabAnchor = styled.a<TabProps>`
    ${tab}
`

export const Tabs = styled.div<TabsProps>`
    display: flex;
    align-items: center;
    overflow-x: ${(props) => (props.scrollHorizontally ? 'auto' : 'initial')};

    > * + * {
        margin-left: ${tokens.spacing40};
    }
`
